import GalleryList from "~/components/GalleryList";
import { getLink, trans } from "~/providers/lang";
import { ROUTES } from "~/const";
import { useSeo } from "~/hooks/useSeo";
import { mainStore } from "~/stores/main";

export default function GalleryWeddingPage() {
	useSeo({
		title: trans("skelet.title.ourcommodity"),
		canonical: "galerie-doplnky",
	});

	const pageData = mainStore(state => state.data.pageData);
	const source = pageData.photos.addons;

	return <GalleryList baseUrl={getLink(ROUTES.galleryAddons)} title={trans("template.addons.title")} desc={trans("template.addons.desc")} desc2={trans("template.addons.desc2")} source={source} />;
}
